import { useCallback, useSyncExternalStore } from 'react';
import { advancedKey, quickFieldsStore } from './advancedStore';

/** Значення швидких полів (поле → значення) типу запису у воркспейсі та їх зміна; спільні для всіх подань модуля, як умови. */
export function useQuickFields(ws: string, rt: string): [Record<string, string>, (next: Record<string, string>) => void] {
  const key = advancedKey(ws, rt);
  const values = useSyncExternalStore(quickFieldsStore.subscribe, () => quickFieldsStore.read(key), () => quickFieldsStore.read(key));
  const set = useCallback((next: Record<string, string>) => quickFieldsStore.write(key, Object.keys(next).length ? next : null), [key]);
  return [values, set];
}
